( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.featured-posts__post a' ).on( 'mouseenter focus', function() {
        const post = $( this ).closest( '.featured-posts__post' );
        const postId = $( post ).attr( 'data-post-id' );
        const image = $( '.featured-posts' ).find( '.featured-posts__post-image[data-post-id="' + postId + '"]' );

        if ( image ) {
          $( image ).addClass( 'is-active' );
        }
      } ).on( 'mouseleave blur', function() {
        const post = $( this ).closest( '.featured-posts__post' );
        const postId = $( post ).attr( 'data-post-id' );
        const image = $( '.featured-posts' ).find( '.featured-posts__post-image[data-post-id="' + postId + '"]' );

        if ( image ) {
          $( image ).removeClass( 'is-active' );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'featured-posts', COMPONENT );
} )( app );
